import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonIconProps, ButtonProps } from '@yooga-tecnologia/mantra/loader';

@Component({
  selector: 'app-bar',
  templateUrl: './app-bar.component.html',
  styleUrls: ['./app-bar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppBarComponent {
  @Input() title: string = '';
  @Input() backButtonProps: ButtonIconProps = {
    icon: 'arrow-left',
    color: 'neutral',
    variant: 'regular',
    size: 'medium',
  };

  @Input() actionButtonProps?: ButtonProps | null = null;
  @Output() backButtonClick = new EventEmitter<void>();
  @Output() actionButtonClick = new EventEmitter<void>();

  constructor() {}

  handleBack() {
    this.backButtonClick.emit();
  }

  handleAction() {
    this.actionButtonClick.emit();
  }
}